// =============[ CSV Utils ]=================
const ERROR_CSV_UNEXPECTED_END = "Unexpected end of CSV string (Double-quote expected)";
const ERROR_CSV_UNEXPECTED_CHARACTER = "Delimiter expected after character";

const STRING_EMPTY = '';
const CHAR_DOUBLE_QUOTE = '"';
const CHAR_SPACE = ' ';
const CHAR_TAB = '\t';
const CHAR_RETURN = '\r';
const CHAR_NEW_LINE = '\n';

const csvToArray = (csvString, delimiter) => {
  if (typeof csvString !== 'string' || !csvString?.length) {
    return [];
  }
  if (typeof delimiter !== 'string' || delimiter?.length !== 1) {
    delimiter = ',';
  }

  // Use direct string indexing (faster than charAt)
  const len = csvString.length;
  let i = 0;
  let row = 0;
  let col = 0;
  const result = [];

  const skipWhitespace = () => {
    while (i < len) {
      const char = csvString[i];
      if (char !== CHAR_SPACE && char !== CHAR_TAB && char !== CHAR_RETURN) {
        break;
      }
      i++;
    }
  };

  while (i < len) {
    skipWhitespace();
    if (i >= len) break;

    // Getting the value
    let value = "";
    const startChar = csvString[i];

    if (startChar === CHAR_DOUBLE_QUOTE) {
      // Read quoted value
      i++; // Skip opening quote
      while (i < len) {
        const char = csvString[i];
        if (char === CHAR_DOUBLE_QUOTE) {
          // Check for escaped double-quote
          if (i + 1 < len && csvString[i + 1] === CHAR_DOUBLE_QUOTE) {
            value += CHAR_DOUBLE_QUOTE;
            i += 2;
          } else {
            i++; // Skip closing quote
            break;
          }
        } else {
          value += char;
          i++;
        }
      }

      if (i >= len && csvString[i - 1] !== CHAR_DOUBLE_QUOTE) {
        throw ERROR_CSV_UNEXPECTED_END;
      }
    } else {
      // Read unquoted value - iterate until delimiter or newline
      while (i < len) {
        const char = csvString[i];
        if (char === delimiter || char === CHAR_NEW_LINE || char === CHAR_TAB || char === CHAR_RETURN) {
          break;
        }
        value += char;
        i++;
      }
    }

    // Add the value to the array
    if (result.length <= row) {
      result.push([]);
    }
    result[row].push(value);

    skipWhitespace();
    if (i >= len) break;

    // Check for column delimiter or newline
    const currentChar = csvString[i];
    if (currentChar === delimiter) {
      col++;
      i++;
    } else if (currentChar === CHAR_NEW_LINE) {
      col = 0;
      row++;
      i++;
    } else if (currentChar !== STRING_EMPTY) {
      throw `${ERROR_CSV_UNEXPECTED_CHARACTER} at row ${row} column ${col}. Character: ${currentChar}. CharacterNumber: ${i}.`;
    }
  }

  return result;
};

const csvToJSObject = (csvString) => {
  const [
    headers,
    ...rows
  ] = csvToArray(csvString);
  return rows.map((row) => row.reduce((acc, cell, index) => {
    acc[headers[index]] = cell;
    return acc;
  }, {}));
};

const loadCsvData = async (url) => {
  const response = await fetch(url);
  const csvString = await response.text();
  const dataObject = csvToJSObject(csvString);
  return dataObject;
};

// =============[ Google Drive Utils ]=================

const convertToDownload = (link) => {
  const url = new URL(link);
  const match = link.match(/\/d\/(.+?)\//);

  if (url.hostname === 'drive.google.com' && match) {
    const fileId = match[1];
    const newUrl = new URL('https://drive.google.com/uc');

    newUrl.searchParams.append('export', 'download');
    newUrl.searchParams.append('id', fileId);

    return newUrl.toString();
  } else {
    throw new Error('Invalid Google Drive link');
  }
}

const convertToPreview = (link) => {
  const url = new URL(link);
  const searchParams = new URLSearchParams(url.search);

  if (url.hostname === 'drive.google.com') {
    return link.replace("edit", "preview");
  } else {
    throw new Error('Invalid Google Drive link');
  }
}

const displayDialog = ({dialog, input, downloadButton}) => {
  document.body.style.overflow = 'hidden';
  const pdfIframe = dialog.querySelector('iframe');
  if (pdfIframe) {
    pdfIframe.src = convertToPreview(input.dataset.url);
  }
  downloadButton.href = convertToDownload(input.dataset.url);
  dialog.style.display = 'flex';
}

const hideCoaDialog = ({dialog}) => (event) => {
  if (event.target === dialog || event.target.dataset.role === 'close') {
    document.body.style.overflow = 'initial';
    const pdfIframe = dialog.querySelector('iframe');
    pdfIframe.src = "";
    dialog.style.display = 'none';
  }
}